import { Injectable } from '@angular/core';
import { Credentials } from './credentials';
import { User } from './user';

export abstract class CurrentUserStore {
  abstract get(): User | null;
  abstract store(user: User): void;
  abstract clear(): void;
}

export abstract class AuthConfig {
  abstract getSlidingExpirationMs(): number;
}

@Injectable()
export class SessionCurrentUserStore extends CurrentUserStore {
  private _key = '________INFORSER_WEBID_credentials';
  private _isAdminKey = '________INFORSER_WEBID_credentials_isAdmin';
  private _expiredKey = '________INFORSER_WEBID_credentials_expired';
  constructor(private _config: AuthConfig) {
    super();
  }

  clear(): void {
    if (sessionStorage.getItem(this._key) !== null) {
      sessionStorage.removeItem(this._key);
    }
    if (sessionStorage.getItem(this._isAdminKey) !== null) {
      sessionStorage.removeItem(this._isAdminKey);
    }
    if (sessionStorage.getItem(this._expiredKey) !== null) {
      sessionStorage.removeItem(this._expiredKey);
    }
  }

  get(): User | null {
    const expired = Number(sessionStorage.getItem(this._expiredKey));
    if (expired && new Date().getTime() - expired > this._config.getSlidingExpirationMs() && this._config.getSlidingExpirationMs() > 0) {
      this.clear();
      return null;
    }
    const key = sessionStorage.getItem(this._key);
    const adminKey = sessionStorage.getItem(this._isAdminKey);
    if (!key || !adminKey) {
      return null;
    }
    return new User(Credentials.fromEncodedString(key), JSON.parse(adminKey));
  }

  store(user: User): void {
    sessionStorage.setItem(this._key, user.credentials.asEncodedString);
    sessionStorage.setItem(this._isAdminKey, JSON.stringify(user.isAdmin));
    sessionStorage.setItem(this._expiredKey, new Date().getTime().toString());
  }
}
